import DeviceManagementComponent from './DeviceManagementComponent';

export default DeviceManagementComponent